import { render, staticRenderFns } from "./shop-product-regular-delivery.vue?vue&type=template&id=24d615a1&scoped=true&"
import script from "./shop-product-regular-delivery.vue?vue&type=script&lang=js&"
export * from "./shop-product-regular-delivery.vue?vue&type=script&lang=js&"
import style0 from "./shop-product-regular-delivery.vue?vue&type=style&index=0&id=24d615a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d615a1",
  null
  
)

export default component.exports